/*
* @TagTable.vue
* @Description 标签管理组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">

            <!-- 表格 -->
            <el-table :data="tagInfos"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      @row-click="rowHandle"
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column label="标签编号(内/外)" min-width="150px" :sortable="filters.sortable" prop="tag_id" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;cursor: pointer;" :title="'室内：' + scope.row.tagId+((scope.row.outId==undefined||scope.row.outId=='')?'':('\n室外：'+scope.row.outId))">
                            {{scope.row.tagId }}
                            <span v-if="(scope.row.outId!=='')">
                                <br /> {{ scope.row.outId}}
                            </span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="短编号" min-width="100px" :sortable="filters.sortable" prop="short_id" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;cursor: pointer;" :title="scope.row.shortId">{{scope.row.shortId}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号" min-width="100px" :sortable="filters.sortable" prop="sid" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.sid">{{scope.row.sid}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="电量" min-width="80px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.battery">{{scope.row.battery + '%'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="在线状态" min-width="80px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="status[scope.row.status]">{{status[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定状态" min-width="100px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="bindingStatus[scope.row.bindingType]">{{bindingStatus[scope.row.bindingType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定名称" min-width="100px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bindingName">{{scope.row.bindingName}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

          <!--查询工具条-->
          <el-col style="text-align: left;">
            <el-form :inline="true" :model="filters" ref="filters">
              <el-form-item>查询条件：</el-form-item>
              <el-form-item prop="status">
                <el-select v-model="filters.status" placeholder="请选择状态" clearable @change="researchTag">
                  <el-option v-for="(value,key) in status" :key="key" :label="value" :value="key" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="keyword">
                <el-input v-model="filters.keyword" placeholder="请输入标签编号/序号" clearable @keyup.enter.native="researchTag" :style="{width: '300px'}">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="researchTag"></i>
                </el-input>
              </el-form-item>
              <el-form-item style="position: absolute;top: 9px;right: 20px;margin: 0;z-index: 3;">
                <el-button v-if="false" type="primary" icon="el-icon-circle-plus-outline" size="mini" @click.native="addTagId">新增号段</el-button>
                <el-dropdown split-button type="primary"  @click="add" trigger="click" size="mini">
                  <i class="el-icon-circle-plus-outline"></i> 新增标签
                  <el-dropdown-menu slot="dropdown" trigger="click">
                    <el-dropdown-item  icon="el-icon-delete" @click.native="deleteRows">批量删除</el-dropdown-item>
                    <el-dropdown-item v-if="false" icon="el-icon-download" @click.native="searchExportData">批量导出</el-dropdown-item>
                    <el-dropdown-item v-if="false">
                      <el-upload
                          accept=".xlsx,.xls"
                          :auto-upload="true"
                          :show-file-list="false"
                          :before-upload="beforeUpload"
                          :on-success="uploadTagIdSuccess"
                          :on-error="uploadError"
                          :action="uploadTagId.uploadUrl"
                          :headers="uploadTagId.myHeaders"
                      >
                        <i class="el-icon-upload2"></i>批量上传编号
                      </el-upload>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-col>

            <!-- 新增标签 -->
            <UwbTagAddDialog   ref="uwbTagAddDialog"
                              :showSerialNumber="upload.showSerialNumber"
                              :uploadUrl="uploadTag.saveUrl"
                              :projectInfos="projectInfos"
                              :previewTitle="upload.previewTitle"
                              :previewData="upload.previewData"
                              @research = "researchTag"
            />

            <!-- 新增标签 -->
            <UwbTagUploadDialog   ref="uwbTagUploadDialog"
                              :showSerialNumber="upload.showSerialNumber"
                              :uploadUrl="upload.saveUrl"
                              :projectInfos="projectInfos"
                              :previewTitle="upload.previewTitle"
                              :previewData="upload.previewData"
                              @research = "researchTag"
            />

            <UwbTagIdAddDialog ref="uwbTagIdAddDialog"  @research = "researchTag" :projectInfos="projectInfos"/>


            <!-- ======================= 导出所需数据 =============================== -->
            <el-table :data="exportDatas"  id="out-table" stripe  style="display: none;" class="table">
                <el-table-column label="标签编号">
                    <template v-slot="scope">
                        {{ (scope.row.outId==undefined||scope.row.outId=='')?scope.row.tagId:scope.row.outId}}
                    </template>
                </el-table-column>
                <el-table-column label="短编号">
                    <template v-slot="scope">
                        {{scope.row.shortId}}
                    </template>
                </el-table-column>
                <el-table-column label="序号">
                    <template v-slot="scope">
                        {{scope.row.sid}}
                    </template>
                </el-table-column>
                <el-table-column label="电量">
                    <template v-slot="scope">
                        {{scope.row.battery + '%'}}
                    </template>
                </el-table-column>
                <el-table-column label="心率">
                    <template v-slot="scope">
                        {{scope.row.heart}}
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template v-slot="scope">
                        {{status[scope.row.status]}}
                    </template>
                </el-table-column>
                <el-table-column v-if="false" label="项目">
                    <template v-slot="scope">
                        {{projectInfos[scope.row.projectId].projectName}}
                    </template>
                </el-table-column>
                <el-table-column label="区域">
                    <template v-slot="scope">
                        {{scope.row.areaName}}
                    </template>
                </el-table-column>
                <el-table-column label="地图">
                    <template v-slot="scope">
                        {{scope.row.mapName}}
                    </template>
                </el-table-column>
                <el-table-column label="基站组">
                    <template v-slot="scope">
                        {{scope.row.groupName}}
                    </template>
                </el-table-column>
                <el-table-column label="X坐标">
                    <template v-slot="scope">
                        {{scope.row.pointX}}
                    </template>
                </el-table-column>
                <el-table-column label="Y坐标">
                    <template v-slot="scope">
                        {{scope.row.pointY}}
                    </template>
                </el-table-column>
                <el-table-column label="Z坐标">
                    <template v-slot="scope">
                        {{scope.row.pointZ}}
                    </template>
                </el-table-column>
                <el-table-column label="绑定状态" min-width="100px">
                    <template v-slot="scope">
                        {{bindingStatus[scope.row.bindingType]}}
                    </template>
                </el-table-column>
                <el-table-column label="绑定名称" min-width="100px">
                    <template v-slot="scope">
                        {{scope.row.bindingNames}}
                    </template>
                </el-table-column>
            </el-table>

        </section>
    </div>

</template>

<script>
    // API oam
	import ApiOam from '@/request/api-oam'
    // 弹框组件
    import UwbTagAddDialog from './UwbTagAddDialog'
    // 分页组件
    import Pagination from '@/components/Pagination.vue'
    // 公共函数
    import GlobalFun from "@/global/global-function";
    import UwbTagIdAddDialog from "./UwbTagIdAddDialog";
    import UwbTagUploadDialog from "./UwbTagUploadDialog";

    export default {
        name: "UwbTagTable",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        components: {
            UwbTagUploadDialog,
            UwbTagIdAddDialog,
            // 基站配置修改弹出层
            // UwbBSConfigDialog,
            // 标签弹出层组件
            UwbTagAddDialog,
            // 分页工具
            Pagination
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        data() {
            return {
                /**
                 * @Des 查询条件属性
                 * @Auth jsh
                 * @Date 09:41 2021/6/28
                 */
                filters: {
                    projectId: this.$store.state.currentProjectId,
                    projectName: this.$store.state.currentProjectName,
                    keyword: '',
                    status: '',
                    orderBy: {
                        "binding_type": 'desc',
                        'binding_name': 'asc',
                        'status': 'asc',
                        "sid": "asc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom',
                },
                // 基站集合
                tagInfos:[],
                exportDatas:[],
                projectInfos: {},
                areas: {},
                maps: {},
                bsGroups: {},
                locked: false,
                status: {
                    1: '在线',
                    2: '离线'
                },
                bindingStatus: {
                    0: '未绑定',
                    1: '绑定人',
                    2: '绑定发动机',
                    3: '绑定车'
                },
                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 50,
                    currentPage: 1
                },
                /**
                 * @Des 上传属性
                 * @Auth Zhangbin
                 * @Date 17:17 2021/4/30
                 */
                upload:{
                    previewTitle: [],
                    previewData: [],
                    saveUrl: '' ,
                    showSerialNumber: true
                },
                /**
                 * 样式修改
                 * */
                surroundSpan(value) {
                    return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
                },
                /**
                 * @Des 上传配置
                 * @Auth Zhangbin
                 * @Date 17:17 2021/4/30
                 */
                uploadTag:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    saveUrl: ApiOam.Add_Uwb_Tag_Uri ,
                },
                /**
                 * @Des 上传配置
                 * @Auth Zhangbin
                 * @Date 17:17 2021/4/30
                 */
                uploadTagId:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    uploadUrl: ApiOam.Batch_Update_Tag_Ids_uri,
                    saveUrl: ApiOam.Add_Uwb_Tag_Id_Batch_Uri,
                },
            }
        },
        computed: {
        },
        created(){
            // 查询登录账户的项目
            //this.searchAccountProject();
            // 查询组织结构
            this.searchOrg();
        },
        mounted(){
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 09:42 2021/6/28
         */
        methods: {
            /**
             * 查询登录账户的项目
             * */
            searchAccountProject() {
                this.$request.postJsonRequest(ApiOam.Find_Login_Project_Uri, {
                }).then(result => {
                    this.projectInfos = Object.assign({}, {});
                    if(result.code == 0){
                        result.data.forEach((row, index) => {
                            let projectId = row.projectId;
                            this.projectInfos[projectId] = row;
                        })
                        this.searchOrg();
                    }
                }).catch(error => {
                    console.error('查询登录项目异常', ApiOam.Find_Login_Project_Uri, error);
                })
            },
            /**
             * 查询组织结构
             * */
            searchOrg() {
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri, {
                	
                }).then(result => {
                    // console.log(result)
                    this.areas = Object.assign({}, {});
                    this.maps = Object.assign({}, {});
                    if(result.code == 0){
                        result.data.forEach((row, index) => {
                            if(this.projectInfos.hasOwnProperty(row.parentId)){
                                // 上级是项目
                                if(this.projectInfos[row.parentId].hasArea == 1){
                                    // 如果有区域
                                    this.areas[row.id] = row.node;
                                }else{
                                    this.maps[row.id] = row.node;
                                }
                            }
                        });
                        result.data.forEach((row, index) => {
                            if(this.areas.hasOwnProperty(row.parentId)){
                                this.maps[row.id] = row.node;
                            }
                        })
                    }
                    this.searchBsGroup();
                }).catch(error => {
                    console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                })
            },

            searchBsGroup(){
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Group_Uri, {
                	
                }).then(result => {
                    this.bsGroups = Object.assign({}, {});
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            this.bsGroups[row.groupId] = row;
                        });
                    }
                    this.searchTag();
                }).catch(error => {
                    console.error('查询基站组异常', ApiOam.Search_Uwb_Bs_Group_Uri, error);
                })
            },

            /**
             * @Des 查询基站
             * @Auth jsh
             * @Date 09:42 2021/6/28
             */
            searchTag() {
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Tag_Uri, {
                    projectId: this.filters.projectId,
                    keyword: this.filters.keyword,
                    status: this.filters.status,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    // console.log(result)
                    this.tagInfos = [];
                    this.pagination.total = result.total;
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            if(this.projectInfos.hasOwnProperty(row.projectId)){
                                row.projectName = this.projectInfos[row.projectId].projectName;
                                row.hasArea = this.projectInfos[row.projectId].hasArea;
                            }
                            // 区域名
                            row.areaName = "";
                            if(row.areaId != undefined && row.areaId != ''){
                                if(this.areas.hasOwnProperty(row.areaId)){
                                    row.areaName = this.areas[row.areaId].areaName;
                                }
                            }
                            // console.log(row.areaId, row.areaName);

                            // 地图
                            if(row.mapId != undefined && row.mapId != ''){
                                if(this.maps.hasOwnProperty(row.mapId)){
                                    row.mapName = this.maps[row.mapId].mapName;
                                }
                            }

                            // 基站组
                            if(row.groupId != undefined && row.groupId != ''){
                                if(this.bsGroups.hasOwnProperty(row.groupId)){
                                    row.groupName = this.bsGroups[row.groupId].groupName;
                                }
                            }

                            this.tagInfos.push(row);
                        });
                    }
                    // console.log(this.bsInfos)
                }).catch(error => {
                    console.error('查询标签异常', ApiOam.Search_Uwb_Tag_Uri, error);
                })
            },

            /**
             * 是否选择
             * */
            checkSelectable(row){
                return true;
            },
            /**
             * 重新搜索
             * */
            researchTag(){
                this.pagination.total = 0;
                this.pagination.startNum = 0;
                this.pagination.currentPage = 1;
                this.searchTag();
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order == null){
                    this.filters.orderBy["sid"] = "asc";
                }else{
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.researchTag();
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
                this.searchTag();
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
                this.searchTag();
            },

            /**
             * 添加基站
             */
            add(){
                this.$request.postJsonRequest(ApiOam.Find_Uwb_UnAdd_Tag_Uri, {
                    orderBy: {
                        status: "asc",
                        sid: "asc"
                    }
                }).then(result => {
                    this.upload.previewTitle = [];
                    this.upload.previewData = [];
                    if(result.data.length == 0){
                        this.$message({
                            message: '未找到新增的标签',
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return;
                    }
                    if(result.code == 0 && result.data){
                        // 显示基站列表信息
                        this.upload.previewTitle.push({
                            label: '标签编号',
                            prop: 'tagId',
                        });
                        this.upload.previewTitle.push({
                            label: '序列号',
                            prop: 'sid',
                        });
                        this.upload.previewTitle.push({
                            label: '电量',
                            prop: 'battery',
                        });
                        this.upload.previewTitle.push({
                            label: '状态',
                            prop: 'statusName',
                        });
                        result.data.forEach((row, index) => {
                            let _row = {
                                tagId: (row.outId==undefined||row.outId=='')?row.tagId:row.outId,
                                id: row.sid,
                                shortId: row.shortId,
                                sid: row.sid,
                                battery: row.battery + '%',
                                heart: row.heart,
                                statusName: this.status[row.status],
                                disabled: false,
                                checked: false,
                            }
                            let _row_ = {};
                            for (let i in _row) {
                                // 外围添加 span
                                _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                            };

                            this.upload.previewData.push(Object.assign({}, _row, _row_));
                        })
                        //弹出预览
                        this.$refs.uwbTagAddDialog.openDialog("添加标签", "确定添加");
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('查询未加入的标签异常', ApiOam.Find_Uwb_UnAdd_Tag_Uri, error);
                })
            },
            /**
             * 删除行
             * @param row
             */
            deleteRow(row){
                this.$confirm(
                    '确认删除标签：'+ row.shortId + '（' + row.sid + '）吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    let param = {
                        sids: [row.sid]
                    };
                    this.delete(param);
                });
            },
            /**
             * 删除多行
             * @param row
             */
            deleteRows(){
                let selection = this.$refs.multipleTable.selection;
                if(selection.length == 0){
                    this.$message({
                        message: '请选择要删除的数据',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量删除选中的信息吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    let sids = [];
                    selection.forEach((row, index) => {
                        sids.push(row.sid);
                    })
                    let param = {
                        sids: sids
                    };
                    this.delete(param);
                });

            },
            delete(param){
                if(this.locked) return;
                this.locked = true;
                this.$request.postJsonRequest(ApiOam.Delete_Uwb_Tag_Uri, param).then(result => {
                    // console.log(result.code);
                    if(result.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.locked = false;
                    this.researchTag();
                }).catch(error => {
                	this.locked = false;
                	console.error('删除标签异常', ApiOam.Delete_Uwb_Tag_Uri, error);
                })
            },
            /**
             * 修改基站配置
             */
            editRowConfig(row, index){
                // console.log(row, index);
                // this.$refs.uwbBSConfigDialog.openDialog(row, index);
            },
            /**
             * 修改标签id
             */
            addTagId(row, index){
                this.$refs.uwbTagIdAddDialog.openDialog('新增标签号段');
            },
            /**
             * 设置基站配置
             */
            setRow(row, index){
                // console.log(row, index);
                setTimeout(()=>{
                    this.$set(this.tagInfos, index, row);
                },1000);
            },
            /**
             * 处理行
             * @param row
             */
            rowHandle(row){
                if(row.checked){
                    row.checked = false;
                }else{
                    row.checked = true;
                }
                this.$refs.multipleTable.toggleRowSelection(row, row.checked)
            },
            /**
             * @Des 查询导出数据
             * @Auth jsh
             * @Date 11:45 2021/7/3
             */
            searchExportData() {
                this.$request.postJsonRequest(ApiOam.Batch_Update_Tag_Ids_uri, {
                }).then(result => {
                    console.log(result)
                    this.exportDatas = Object.assign({}, {});
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            if(this.projectInfos.hasOwnProperty(row.projectId)){
                                row.projectName = this.projectInfos[row.projectId].projectName;
                                row.hasArea = this.projectInfos[row.projectId].hasArea;
                            }
                            // 区域名
                            row.areaName = "";
                            if(row.areaId != undefined && row.areaId != ''){
                                if(this.areas.hasOwnProperty(row.areaId)){
                                    row.areaName = this.areas[row.areaId].areaName;
                                }
                            }
                            // console.log(row.areaId, row.areaName);

                            // 地图
                            if(row.mapId != undefined && row.mapId != ''){
                                if(this.maps.hasOwnProperty(row.mapId)){
                                    row.mapName = this.maps[row.mapId].mapName;
                                }
                            }

                            // 基站组
                            if(row.groupId != undefined && row.groupId != ''){
                                if(this.bsGroups.hasOwnProperty(row.groupId)){
                                    row.groupName = this.bsGroups[row.groupId].groupName;
                                }
                            }
                            this.exportDatas.push(row);
                        });
                    }
                    this.$nextTick(()=>{
                        GlobalFun.exportExcel(document.querySelector("#out-table"),'uwb标签信息.xlsx');
                    })
                }).catch(error => {
                    console.error('导出标签异常', ApiOam.Batch_Update_Tag_Ids_uri, error);
                })
            },

            /**
             * @Des 上传之前的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            beforeUpload(file){
                // 上传之前
                // console.log(file)
                this.upload.previewTitle = Object.assign([], []);
                this.upload.previewData = Object.assign([], []);
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(extension !== 'xlsx') {
                    this.$message.warning('只能上传后缀是.xlsx的文件');
                }
                if(size > 10) {
                    this.$message.warning('文件大小不得超过10M');
                }
            },

            /**
             * @Des 上传成功后的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            uploadTagIdSuccess(res, file, fileList) {
                // 上传成功
                // console.log(res, file, fileList);
                // console.log(this.upload.fileType)
                if(res.code == 0){
                    // 返回数据
                    console.log(res.data)
                    // 显示标签列表信息
                    this.upload.previewTitle.push({
                        label: '标签编号',
                        prop: 'tagId',
                    });
                    this.upload.previewTitle.push({
                        label: '短编号',
                        prop: 'shortId',
                    });
                    this.upload.previewTitle.push({
                        label: '序列号',
                        prop: 'sid',
                    });
                    this.upload.previewTitle.push({
                        label: '信息',
                        prop: 'message',
                    });
                    res.data.forEach((row, index) => {
                        let addCell = {
                            tagId: (row.outId==undefined||row.outId=='')?row.tagId:row.outId,
                            id: row.sid,
                            disabled: row.code==0?false:true,
                            checked: row.code==0?true:false,
                        }
                        let _row = Object.assign({},row, addCell);

                        let _row_ = {};
                        for (let i in _row) {
                            // 外围添加 span
                            _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                        };

                        this.upload.previewData.push(Object.assign({}, _row, _row_));
                    })

                    this.upload.showSerialNumber = true;
                    this.upload.saveUrl = this.uploadTagId.saveUrl;
                    //弹出预览
                    this.$refs.uwbTagUploadDialog.openDialog("标签编号上传修改预览", "确定上传", 1);
                    // console.log(res.data)
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                }
            },

            /**
             * @Des 上传失败后的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
            },

        },


    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbTagTable.vue